export const DEFAULT_CRM_TOKEN = 'gbon2r2lqj5';
export const AGENCY_ID = 708;
export const brandLogo = `${window.assetsLocation}/images/logo.png`;
export const brandLogoSecondary = `${window.assetsLocation}/images/logo2.png`;
export const brandShowcaseUrl = `${window.assetsLocation}/images/showcase.png`;
export const bannerUrl = `${window.assetsLocation}/images/banner.png`;
export const viewReportIconUrl = `${window.assetsLocation}/images/carousel.png`;
export const twitterXIcon = `${window.assetsLocation}/images/x.svg`;
export const homeArticleIds = ['3'];
export const faqArticleIds = [
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    '10',
    '11',
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
];
export const portalHomeUrl = 'https://lomalindaca.comcate.com/';
export const portalName = 'Loma Linda Help Center';
